import { render, staticRenderFns } from "./AddGroupGoodsForm.vue?vue&type=template&id=79c94f98"
import script from "./AddGroupGoodsForm.vue?vue&type=script&lang=js"
export * from "./AddGroupGoodsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports